const e = "_ctaBanner_y2e1q_1", a = "_lg_y2e1q_32", n = "_arrowSmall_y2e1q_35", r = "_arrowLarge_y2e1q_38", t = "_blue_y2e1q_62", _ = "_content_y2e1q_83", o = {
  ctaBanner: e,
  lg: a,
  arrowSmall: n,
  arrowLarge: r,
  blue: t,
  content: _
};
export {
  r as arrowLarge,
  n as arrowSmall,
  t as blue,
  _ as content,
  e as ctaBanner,
  o as default,
  a as lg
};
//# sourceMappingURL=cta-banner.module.less.js.map
